






































































import Vue from "vue";
// TODO : eslintでno-unused-varsのwarningが出ているので、Vue3へのアップデート時に対応検討する
import InvestmentOption, { InvestmentOptionType } from "@components/partials/public/projects/InvestmentOption.vue";

type DataType = {
  investmentOption: InvestmentOptionType
  isProfessionalInvestor: boolean
  options: Record<string, unknown>
}

export default Vue.extend({
  components: {
    InvestmentOption
  },
  props: {
    investmentOptionJsonString: {
      type: String,
      required: true,
    },
    isProfessionalInvestorString: {
      type: String,
      required: true,
    }
  },
  data(): DataType {
    const investmentOption = JSON.parse(this.investmentOptionJsonString);
    const isProfessionalInvestor: boolean = this.isProfessionalInvestorString === "true"
    return {
      investmentOption,
      isProfessionalInvestor,
      options: {
        width: "90%",
        maxWidth: 600,
        height: "auto",
      }
    };
  },
  computed: {
    hasUninvestableOptionByInvestorLimit(): boolean {
      return this.investmentOption.withinInvestorInvestmentAmountLimit === false
    },
    canNotApplyWaitingList(): boolean {
      return !this.investmentOption.canApplyWaitingList
    }
  },
  methods: {
    modalShow(): void {
      this.$modal.show('ApplyWaitingListByInvestmentOptionModal');
    },
  }
});
